import { UseMediaLoader } from '@/shared/composables/useMediaLoader.ts';
import { VideoBibleChapterQuery } from '@/core/graphql/types.ts';
import { IRoadmapItem, Maybe } from '@/shared/types';
import { Slide } from '@/shared/types/interactive-bible-slides.ts';
import { InjectionKey, Ref } from 'vue';

export const activeRoadmapItemInjectionKey = Symbol() as InjectionKey<Ref<Maybe<IRoadmapItem>>>;

export const activeSlideInjectionKey = Symbol() as InjectionKey<Ref<Maybe<Slide>>>;

export const roadmapItemInjectionKey = Symbol() as InjectionKey<IRoadmapItem>;

export const slideInjectionKey = Symbol() as InjectionKey<Ref<Maybe<Slide>>>;

export const mediaLoaderInjectionKey = Symbol() as InjectionKey<UseMediaLoader>;

export const videoBibleChapterInjectionKey = Symbol() as InjectionKey<Readonly<Ref<Maybe<VideoBibleChapterQuery['videoBibleChapter']>>>>;
